'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _debugDocumentModeReducer = require('./documentMode/debugDocumentModeReducer');

var _debugDocumentModeReducer2 = _interopRequireDefault(_debugDocumentModeReducer);

var _debugConstants = require('./debugConstants');

var _debugDocumentModeConstants = require('./documentMode/debugDocumentModeConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Reducers


// Constants


var enabledReducer = function enabledReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];
    return action.type === _debugConstants.ENABLE_DEBUG_TOOLS ? true : state;
};

var debugReducer = (0, _reduxImmutable.combineReducers)(_defineProperty({
    enabled: enabledReducer
}, _debugDocumentModeConstants.DOC_MODE_DEBUG_TOOL_NAME, _debugDocumentModeReducer2.default));

var initialState = Immutable.Map();
var wrappedDebugReducer = function wrappedDebugReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!state.get('enabled') && action.type !== _debugConstants.ENABLE_DEBUG_TOOLS) return state;
    return debugReducer(state, action);
};

exports.default = wrappedDebugReducer;


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/debugReducer.js
// module id = 1939
// module chunks = 0